const InputValidationMessage = ({children}: any) => {
  return <div style={{color: 'red', fontWeight: 400, fontSize: '.9rem'}}>{children}</div>
}

export default InputValidationMessage
